import RMButton from 'components/customComponents/Controls/RMButton';
import React, { useState } from 'react';
import MiscService from 'business/services/MiscService';
import { ResponseType } from 'business/models/Models';
import { showAlertSnackBar, validateEmail } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import RMTextInput from 'components/customComponents/Controls/RMTextInput';
import { emailErrorMessage } from 'CustomHooks/useSendTestEmail';

export const LabwareReport = () => {
  const [emailAddress, setEmailAddress] = useState<string>('');

  const handleOnClickSendEmail = async () => {
    const isEmailValid: boolean = validateEmail(emailAddress);
    if (!isEmailValid) {
      showAlertSnackBar(
        EAlertType.WARNING,
        ESnackBarPosition.TOP,
        'Email address is not valid.',
      );
      return;
    }

    showAlertSnackBar(
      EAlertType.INFO,
      ESnackBarPosition.TOP,
      'Sending labware report email.',
    );
    const miscService = new MiscService();
    const res = await miscService.sendLabwareReportEmail(emailAddress);
    if (res) {
      let resMessage = '';
      if (ResponseType[res.responseType] === 'Info') {
        resMessage = res.message;
        showAlertSnackBar(EAlertType.SUCCESS, ESnackBarPosition.TOP, resMessage);
        setEmailAddress('');
      } else {
        resMessage = emailErrorMessage;
        showAlertSnackBar(EAlertType.ERROR, ESnackBarPosition.TOP, resMessage);
      }
    }
  };

  const handleOnChangeEmailAddress = (e) => {
    setEmailAddress(e.target.value);
  };

  return (
    <div
      id="labwarereport-wrapper"
      className="border-1 border-solid border-[#E0E0E0] h-[100%] w-[100%] p-2"
    >
      <b id="labwarereport-title" className="text-[14px] 2xl:text-[18px]">
        Consumable Report
      </b>
      <div
        id="labwarereport-description"
        className="mt-[10px] text-[12px] 2xl:text-[16px]"
      >
        This report provides insights into your consumable usage, including:
      </div>
      <div
        id="labwarereport-description-list"
        className="flex flex-col mt-[5px] ml-[5px] text-[12px] 2xl:text-[16px]"
      >
        <div id="labwarereport-description-first" className="flex flex-row">
          <div id="labwarereport-description-first-number">1.</div>
          <div id="labwarereport-description-first-content" className="ml-[5px]">
            The number and average volume of screens used over the past year.
          </div>
        </div>
        <div id="labwarereport-description-second" className="flex flex-row">
          <div id="labwarereport-description-second-number">2.</div>
          <div id="labwarereport-description-second-content" className="ml-[5px]">
            The number of used and imaged plate types.
          </div>
        </div>
      </div>

      <div id="labwarereport-emailaddress" className="flex items-center w-full mt-3">
        <div
          id="labwarereport-emailaddress-title"
          className="w-[17%] text-[12px] 2xl:text-[16px]"
        >
          Email Address
        </div>
        <RMTextInput
          placeHolder="Example@email.com"
          value={emailAddress}
          className="w-[62%] h-[28px] text-[14px] 2xl:text[18px] ml-[1.5%]"
          onChange={handleOnChangeEmailAddress}
          style={{}}
        />
        <div
          id="labwarereport-emailaddress-sendbutton"
          className="flex flex-row justify-end text-right w-[19%] ml-[1.5%]"
        >
          <RMButton
            className="w-[79px] text-[13px]"
            customStyle={{ background: '#000000' }}
            onClick={handleOnClickSendEmail}
            disabled={false}
            label="Send"
          />
        </div>
      </div>
    </div>
  );
};
